module.exports = __webpack_public_path__ + "static/media/card5_2.90988572.png";